<template>
  <div
    :class="[
      'm-3 rounded-lg border border-gray-200 bg-white p-2 shadow dark:border-gray-700 dark:bg-gray-800'
    ]"
  >
    <div ref="contentRef">
      <div class="flex items-center justify-between">
        <div class="flex items-center">
          <span
            class="material-symbols-outlined notranslate text-basic"
            translate="no"
            aria-hidden="true"
          >
            {{ props.card.EntityCard.icon }}</span
          >
          <span class="ml-1">{{
            `${props.card.EntityCard.title} ${props.card.EntityCard.action}`
          }}</span>
        </div>
        <div class="flex items-center">
          <SimpleIconButton v-if="isEditable" @click="handleEditClick()">
            <template #icon>edit</template>
            <template #popper>{{ $t('ui.common.edit') }}</template>
          </SimpleIconButton>

          <SimpleIconButton class="mx-2" @click="handleDeleteClick()">
            <template #icon>delete</template>
            <template #popper>{{ $t('ui.common.delete') }}</template>
          </SimpleIconButton>
        </div>
      </div>
      <div class="my-2 flex items-center justify-between break-all">
        {{ props.card.EntityCard.subTitle }}
      </div>
      <div
        v-for="modifiedField in props.card.EntityCard.modifiedFields"
        :key="modifiedField"
        class="whitespace-pre-line break-all"
      >
        {{ modifiedField }}
      </div>
      <div>
        <div v-if="props.card.EntityCard.isError" class="mt-2">
          <div
            v-if="
              props.card.EntityCard.relationErrorMessages &&
              props.card.EntityCard.relationErrorMessages.length > 0
            "
          >
            <div
              v-for="message in props.card.EntityCard.relationErrorMessages"
              :key="message"
              class="mb-1 flex items-center text-red-500"
            >
              <span
                class="material-symbols-outlined notranslate mr-1 text-red-500"
                translate="no"
                aria-hidden="true"
                >error</span
              >
              {{ message }}
            </div>
          </div>
          <div v-else class="flex items-center text-red-500">
            <span
              class="material-symbols-outlined notranslate mr-1 text-red-500"
              translate="no"
              aria-hidden="true"
              >error</span
            >
            {{ $t('ui.common.fixError') }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { stageCard } from '@/lib/stageCardUtil'
import { computed } from 'vue'

import SimpleIconButton from '@/components/SimpleIconButton.vue'

const props = defineProps<{ card: stageCard }>()
const emits = defineEmits(['stage-card-edit', 'stage-card-delete'])

const isEditable = computed(() => {
  const excludeEditIconKeys = ['attendance', 'work_on_project']
  return !excludeEditIconKeys.some((key) => props.card.stageKeys[0].includes(key))
})

const handleEditClick = () => {
  emits('stage-card-edit')
}

const handleDeleteClick = () => {
  emits('stage-card-delete')
}
console.debug('StageCard props:', props.card)
</script>
